import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { DefaultButton, Panel, PanelType, Persona, PersonaSize, Stack } from '@fluentui/react';
import Text from '../../../../../typography/text';
import LoadingComponent from '../../../../../feedbacks/loading';
import { IVersionHistoryResourceShortProps } from '../../../../../../props/general/versionHistory';
import GeneralService from '../../../../../../services/general';
import moment from 'moment';
import IncomeInvoiceService from '../../../../../../services/finance/incomes/invoices/invoice';
import { IIncomeInvoiceResourceProps } from '../../../../../../props/finance/incomes/invoices/invoice';

type IncomeInvoiceVersionHistoryProps = {
    invoiceId: string;
    onDismissed(refresh?: boolean): void;
}

const IncomeInvoiceVersionHistory: React.FC<IncomeInvoiceVersionHistoryProps> = (props: IncomeInvoiceVersionHistoryProps) => {
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [versions, setVersions] = React.useState<IVersionHistoryResourceShortProps[]>([]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            const _versions = await IncomeInvoiceService.versions.retrieve(props.invoiceId);
            setLoaded(true);
            setVersions(_versions);
        } catch (e) {

        }
    }

    const renderVersion = (_version: IVersionHistoryResourceShortProps, idx: number) => {
        const invoice = _version.data as Partial<IIncomeInvoiceResourceProps>;


        return <Stack horizontal tokens={{ childrenGap: 20 }}>
            <Stack className={styles.indicator}>
                <Stack className={`${styles.dot} ${idx === 0 ? styles.active : ''}`}></Stack>
                {idx < versions.length - 1 ? <Stack className={styles.line}></Stack> : null}
            </Stack>
            <Stack grow={1} tokens={{ childrenGap: 10 }} className={styles.card}>
                <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign={'center'}>
                    <Stack>
                        <Persona text={_version.createdBy.name} imageInitials={GeneralService.getInitial(_version.createdBy.name)} size={PersonaSize.size24} />
                    </Stack>
                    <Text size={'small'}>|</Text>
                    <Text size={'small'}>{moment(_version.createdAt).format("DD/MM/YYYY HH:mm")}</Text>
                </Stack>
                <Stack className='divider'></Stack>
                <Stack>
                    <Text size={'small'} style={{ fontStyle: 'italic' }}>{_version.notes}</Text>
                </Stack>
                <Stack className='divider'></Stack>
                <Stack>
                    <table className={styles.table}>
                        {invoice.name ? <tr>
                            <td className={styles.title}><Text size={'small'}>Name</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.name}</Text></td>
                        </tr> : null}
                        {invoice.notes ? <tr>
                            <td className={styles.title}><Text size={'small'}>Notes</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.notes}</Text></td>
                        </tr> : null}
                        {invoice.subsidiary ? <tr>
                            <td className={styles.title}><Text size={'small'}>Subsidiary</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.subsidiary}</Text></td>
                        </tr> : null}
                        {invoice.bankAccount ? <tr>
                            <td className={styles.title}><Text size={'small'}>Transfer to</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.bankAccount.accountName} - {invoice.bankAccount.accountNumber} - {invoice.bankAccount.bank?.name}</Text></td>
                        </tr> : null}
                        {invoice.dueDate ? <tr>
                            <td className={styles.title}><Text size={'small'}>Due date</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{moment(invoice.dueDate).format("DD/MM/YYYY")}</Text></td>
                        </tr> : null}
                        {invoice.status ? <tr>
                            <td className={styles.title}><Text size={'small'}>Status</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.status}</Text></td>
                        </tr> : null}
                        {invoice.totalAmount ? <tr>
                            <td className={styles.title}><Text size={'small'}>Total amount</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>Rp. {GeneralService.getNumberWithSeparator(Number(invoice.totalAmount))}</Text></td>
                        </tr> : null}
                        {invoice.ppnPercentage ? <tr>
                            <td className={styles.title}><Text size={'small'}>PPn %</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.ppnPercentage === 'custom' ? 'custom' : GeneralService.getNumberWithSeparator(Number(invoice.ppnPercentage)) + "%"}</Text></td>
                        </tr> : null}
                        {invoice.ppn ? <tr>
                            <td className={styles.title}><Text size={'small'}>PPn</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>Rp. {GeneralService.getNumberWithSeparator(Number(invoice.ppn))}</Text></td>
                        </tr> : null}
                        {invoice.pphPercentage ? <tr>
                            <td className={styles.title}><Text size={'small'}>PPh %</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>{invoice.pphPercentage === 'custom' ? 'custom' : GeneralService.getNumberWithSeparator(Number(invoice.pphPercentage)) + "%"}</Text></td>
                        </tr> : null}
                        {invoice.pph ? <tr>
                            <td className={styles.title}><Text size={'small'}>PPh</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'}>Rp. {GeneralService.getNumberWithSeparator(Number(invoice.pph))}</Text></td>
                        </tr> : null}
                        {invoice.paid ? <tr>
                            <td className={styles.title}><Text size={'small'}>Paid amount</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'} className={'color-green'}>Rp. {GeneralService.getNumberWithSeparator(Number(invoice.paid))}</Text></td>
                        </tr> : null}
                        {invoice.unpaid ? <tr>
                            <td className={styles.title}><Text size={'small'}>Unpaid amount</Text></td>
                            <td className={styles.separator}><Text size={'small'}>:</Text></td>
                            <td className={styles.content}><Text size={'small'} className={'color-red'}>Rp. {GeneralService.getNumberWithSeparator(Number(invoice.unpaid))}</Text></td>
                        </tr> : null}
                    </table>
                </Stack>
            </Stack>
        </Stack>;
    }

    const compareVersion = (currentVersion: IVersionHistoryResourceShortProps, previousVersion: IVersionHistoryResourceShortProps) => {
        const currentInvoice = currentVersion.data as IIncomeInvoiceResourceProps;
        const previousInvoice = previousVersion.data as IIncomeInvoiceResourceProps;
        const cleaninvoice: Partial<IIncomeInvoiceResourceProps> = {};

        if (currentInvoice.subsidiary?.id !== previousInvoice.subsidiary?.id) {
            cleaninvoice.subsidiary = currentInvoice.subsidiary;
        }

        if (currentInvoice.bankAccount?.id !== previousInvoice.bankAccount?.id) {
            cleaninvoice.bankAccount = currentInvoice.bankAccount;
        }

        if (currentInvoice.dueDate !== previousInvoice.dueDate) {
            cleaninvoice.dueDate = currentInvoice.dueDate;
        }
        
        if (currentInvoice.notes !== previousInvoice.notes) {
            cleaninvoice.notes = currentInvoice.notes;
        }
        
        if (currentInvoice.name !== previousInvoice.name) {
            cleaninvoice.name = currentInvoice.name;
        }
        
        if (currentInvoice.totalAmount !== previousInvoice.totalAmount) {
            cleaninvoice.totalAmount = currentInvoice.totalAmount;
        }
        
        if (currentInvoice.subtotalAmount !== previousInvoice.subtotalAmount) {
            cleaninvoice.subtotalAmount = currentInvoice.subtotalAmount;
        }
        
        if (currentInvoice.ppn !== previousInvoice.ppn) {
            cleaninvoice.ppn = currentInvoice.ppn;
        }
        
        if (currentInvoice.pph !== previousInvoice.pph) {
            cleaninvoice.pph = currentInvoice.pph;
        }
        
        if (currentInvoice.ppnPercentage !== previousInvoice.ppnPercentage) {
            cleaninvoice.ppnPercentage = currentInvoice.ppnPercentage;
        }
        
        if (currentInvoice.pphPercentage !== previousInvoice.pphPercentage) {
            cleaninvoice.pphPercentage = currentInvoice.pphPercentage;
        }
        
        if (currentInvoice.status !== previousInvoice.status) {
            cleaninvoice.status = currentInvoice.status;
        }
        
        if (currentInvoice.paid !== previousInvoice.paid) {
            cleaninvoice.paid = currentInvoice.paid;
        }
        
        if (currentInvoice.unpaid !== previousInvoice.unpaid) {
            cleaninvoice.unpaid = currentInvoice.unpaid;
        }
        
        if (currentInvoice.paidOn !== previousInvoice.paidOn) {
            cleaninvoice.paidOn = currentInvoice.paidOn;
        }
        
        if (currentInvoice.justification !== previousInvoice.justification) {
            cleaninvoice.justification = currentInvoice.justification;
        }

        return { ...currentVersion, data: cleaninvoice };
    }

    return <Panel headerText={"Version History"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <DefaultButton text={"Close"} onClick={() => { props.onDismissed(false) }} />
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 20 } }}>
            {!loaded ? <LoadingComponent label='Retrieving version history ...' labelPosition='right' spinnerPosition='baseline' /> : null}
            {loaded ? <>
                <Stack tokens={{ childrenGap: 20 }} className={styles.timeline}>
                    {versions.sort((a, b) => (a.createdAt > b.createdAt) ? 1 : ((b.createdAt > a.createdAt) ? -1 : 0)).reverse().map((version, idx) => {
                        const currentVersion = version;
                        const previousVersion = versions[idx + 1] ? versions[idx + 1] : undefined;

                        if (previousVersion) {
                            const updated = compareVersion(currentVersion, previousVersion);
                            return renderVersion(updated, idx);
                        } else {
                            return renderVersion(currentVersion, idx);
                        }
                    })}
                </Stack>
            </> : null}
        </Stack>
    </Panel>
};

export default IncomeInvoiceVersionHistory;
